<template>
  <div class="pageCompany">
    <div class="container h-100">
      <NavButton />
      <b-row class="h-100 justify-content-center align-items-center">
        <b-col class="col-6 col-sm-4 col-md-4 col-lg-4" 
          v-for="(item, index) in allFarm"
          :key="index"
          :value="item"
        >
          <b-row class="p-2 h-100">
            <b-col class="col-12 text-center bg-company hover-up rounded-20">
              <b-button variant="transparent" class="text-light" @click="selectFarm(allFarm[index].url)">
                <img src="../assets/img/swine-company-name.png" class="w-75">
                <h5 class="font-weight-bold">{{allFarm[index].name_th}}</h5>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <!-- <b-col class="col-6 col-sm-4 col-md-4 col-lg-4">
          <b-row class="p-2 h-100">
            <b-col class="col-12 text-center bg-company hover-up rounded-20">
              <a class="text-light" href="../company-khonkaen" target="_blank">
                <img src="../assets/img/swine-company-name.png" class="w-75">
                <h5 class="font-weight-bold">ฟาร์มนครราชสีมา</h5>
              </a>
            </b-col>
          </b-row>
        </b-col>
       <b-col class="col-6 col-sm-4 col-md-4 col-lg-4">
          <b-row class="p-2 h-100"> 
            <b-col class="col-12 text-center bg-company hover-up rounded-20">
                <a class="text-light" href="#" target="_blank">
                  <img src="../assets/img/swine-company-name.png" class="w-75">
                  <h5 class="font-weight-bold">ฟาร์มสีคิ้ว</h5>
                </a>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="col-6 col-sm-4 col-md-4 col-lg-4">
          <b-row class="p-2 h-100">
            <b-col class="col-12 text-center bg-company hover-up rounded-20">
              <a class="text-light" href="#" target="_blank">
                <img src="../assets/img/swine-company-name.png" class="w-75">
                <h5 class="font-weight-bold">ฟาร์มหนองคาย</h5>
              </a>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="col-6 col-sm-4 col-md-4 col-lg-4">
          <b-row class="p-2 h-100">
            <b-col class="col-12 text-center bg-company hover-up rounded-20">
              <a class="text-light" href="#" target="_blank">
                <img src="../assets/img/swine-company-name.png" class="w-75">
                <h5 class="font-weight-bold">ฟาร์มกาญจนบุรี</h5>
              </a>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="col-6 col-sm-4 col-md-4 col-lg-4">
          <b-row class="p-2 h-100">
            <b-col class="col-12 text-center bg-company hover-up rounded-20">
              <a class="text-light" href="#" target="_blank">
                <img src="../assets/img/swine-company-name.png" class="w-75">
                <h5 class="font-weight-bold">ฟาร์มบ่อพลอย</h5>
              </a>
            </b-col>
          </b-row>
        </b-col> -->
         <!-- <b-col class="col-12">
          <router-link :to="{name: 'home'}"><b-button variant="light">ย้อนกลับ</b-button></router-link>
        </b-col> -->
      </b-row>
      <Footer />
    </div>
  </div>
</template>

<script>
import NavButton from "@/components/NavButton.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "company",
  components: {
    NavButton,
    Footer
  },
  data() {
    return {
      allFarm: [],
    }
  },
  mounted() {
    if(this.$store.getters.loggedIn == true) {
      localStorage.removeItem('farm_id')
      this.viewFarm()
    }
    else {
      this.$nextTick(() => {
        this.$router.push({
          name: "login"
        });
      });
    }
  },
  methods: {
    viewFarm() {
      if(localStorage.getItem('farm_id') == null) {
        this.$store.dispatch('viewFarmAdminAll')
        .then(response => {
          if(response.data.success == 1) {
            for(let i = 0 ; i < response.data.data.length ; i++) {
              let farm_token = (response.data.data[i].farm_token)
              let agency = farm_token.slice(1,2)
              // let animal = farm_token.slice(2, 3);
              // let farm_id = farm_token.slice(4,7)

              if(agency == '1') {
                response.data.data[i].name_en = response.data.data[i].name_en.toString()
                response.data.data[i].name_en = response.data.data[i].name_en.replace(/_/g, "")
                this.allFarm.push({
                  name_th: response.data.data[i].name_th,
                  url: "swine/company/" + response.data.data[i].name_en + "/#/redirect/?farm_id=" + response.data.data[i].farm_id + "&name_th=" + response.data.data[i].name_th + "&name_en=" + response.data.data[i].name_en + "&user_id=" + localStorage.getItem('user_id') + "&role=" + localStorage.getItem('role') + "&token=" + localStorage.getItem('access-token') + "&verify=" + localStorage.getItem('verify-token')
                })
              }
            }          
          }
        })
      }
      else if(localStorage.getItem('farm_id') == 1) {
        this.$store.dispatch('viewFarmActive')
        .then(response => {
          if(response.data.success == 1) {
            for(let i = 0 ; i < response.data.data.length ; i++) {
              let farm_token = (response.data.data[i].farm_token)
              let agency = farm_token.slice(1,2)
              // let farm_id = farm_token.slice(4,7)

              if(agency == '1') {
                response.data.data[i].name_en = response.data.data[i].name_en.toString()
                response.data.data[i].name_en = response.data.data[i].name_en.replace(/_/g, "")
                this.allFarm.push({
                  name_th: response.data.data[i].name_th,
                  url: "swine/company/" + response.data.data[i].name_en + "/#/redirect/?farm_id=" + response.data.data[i].farm_id + response.data.data[i].farm_id + "&name_th=" + response.data.data[i].name_th + "&name_en=" + response.data.data[i].name_en + "&user_id=" + localStorage.getItem('user_id') + "&role=" + localStorage.getItem('role') + "&token=" + localStorage.getItem('access-token') + "&verify=" + localStorage.getItem('verify-token')
                })
              }
            }          
          }
        })
      }
    },
    selectFarm(url) {
      console.log(url)
      window.location = url
    }
  }
};
</script>

<style scoped>
@import "../assets/css/Page.css";
@import "../assets/css/Font.css";

  .pageCompany {
    padding-top: 30px;
    padding-bottom: 30px;
    height: auto;
    min-height: 100%;
    background-color: #0cbaba;
    background-image: linear-gradient(315deg, #0cbaba 0%, #380036 74%);
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
  }

  .btn:disabled, input:disabled, select:disabled {
    cursor: not-allowed;
  }
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px 555555; 
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: #00FFFF; 
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #00FFFF; 
  }
  
  .bg-promote {
    background-color: #69140e;
    background-image: linear-gradient(315deg, #69140e 0%, #d58936 74%);
  }
  .bg-company {
    background-color: #0d0a0b;
    background-image: linear-gradient(315deg, #0d0a0b 0%, #009fc2 74%);
  }
  .rounded-20{
    border: 0px solid #ffffff;
    padding: 10px;
    border-radius: 20px;
  }
  .hover-up {
    transform: scale(1);
    transition: .3s ease;
    cursor: pointer;
  }
  .hover-up:hover {
      transform: scale(0.9);
  }
</style>
